var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"status-in-table"},[_c('span',{staticClass:"font-Regular-10",class:_vm.params.value.style + '-status'},[_vm._v(_vm._s(_vm.params.value.locale))])])}
var staticRenderFns = []

export { render, staticRenderFns }